<template>
    <v-dialog v-model="dialogProp" width="500">
        <v-card>
            <v-toolbar flat>
                <v-spacer />
                <v-btn icon @click="dialogProp = false">
                    <v-icon>{{ mdiClose }}</v-icon>
                </v-btn>
            </v-toolbar>
            <v-card-title>
                <h4 style="word-break: break-word;">
                    Dental Care:
                </h4>
                <h6 style="word-break: break-word;">
                    For members with Dental Option. Dental care under your HMI Plan
                    includes the following services:
                </h6>
            </v-card-title>
            <v-divider />

            <v-card-text>
                <ul v-for="(desc, i) in descs" :key="i">
                    <li>{{ desc }}</li>
                </ul>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
import { mdiClose } from '@mdi/js'

export default {
    props: ['showDental'],

    data: () => ({
        mdiClose,
        descs: [
            'Dental Examinations consisting of taking of dental history/record and, where applicable, recommendation of dental treatment or procedure.',
            'Consultations, excluding prescribed medicines.',
            'Dental Extractions, except complicated extractions.',
            'Simple Oral Prophylaxis (available only after six (6) months of continuous membership with HMI).',
            'Re-cementation of loose crown bridges.',
            'Temporary fillings.',
            'Simple adjustment of dentures.'
        ]
    }),
    computed: {
        dialogProp: {
            get() {
                return this.showDental
            },
            set(val) {
                this.$emit('showDialog', val)
            }
        }
    }
}
</script>

<style scoped>
ul li {
  font-size: 13px;
  padding-top: 10px;
  color: black;
}
h6 {
  font-weight: normal;
  font-size: 15px;
  color: black;
  line-height: 1.5em;
  width: 100%;
  padding: 0px 10px;
  margin: auto;
}
@media (max-width: 599px) {
  h6 {
    padding: 0px;
    line-height: 1.2em;
    font-size: 12.5px;
  }
}
</style>
